import React from "react";

import './course.styles.scss';

const Course = ({ title, link, icon, languages, tools, grade, description }) => (
  <div className='courses'>
    <div className='courses-left'>
      <img alt={title} src={icon} className='courses-icon' />
    </div>

    <div className='courses-text'>
      <div className='courses-header'>
        <h1 className='courses-title'>{title}</h1>
      </div>
      <p className='courses-content'>
        <b>Languages: </b>{languages.join(', ')}<br />
        {tools.length !== 0 ? <><b>Tools: </b>{tools.join(', ')}<br /></> : null}
        <b>Final Grade: </b>{grade}<br />
        <b>Description: </b>{description}<br />
        <a target='_blank' rel='noreferrer' href={link}>Click for more information</a>
      </p>
    </div>

    <hr className='mid' />
  </div>
);

export default Course;
